import { Box } from 'grid-styled';

const Grid = Box.extend`
  display: inline-block;
`;

Grid.displayName = 'Grid';

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid.js